
  import Vue from 'vue'
  import SpaceStatistic from '@/components/SpaceStatistic.vue'

  export default Vue.extend({
    name: 'Statistic',
    components: {
      SpaceStatistic
    },
    created() {
      document.title = this.$vuetify.lang.t("$vuetify.tab_titles.admin_statistics")
    }
  })
